import Text from "../../../../../../packages/design-system/src/Text";
import ErrorSummary from "../../../../../../packages/design-system/src/ErrorSummary";
import * as React from 'react';
export default {
  Text,
  ErrorSummary,
  React
};